export const FA_ICONS = [
  // People & Users
  "FaUser","FaUserCircle","FaUserPlus","FaUserMinus","FaUserCheck","FaUserSlash",
  "FaUserTie","FaUserSecret","FaUserShield","FaUserLock","FaUserCog","FaUserEdit",
  "FaUserTag","FaUserClock","FaUsers",
  // Communication
  "FaEnvelope","FaEnvelopeOpen","FaEnvelopeOpenText","FaInbox",
  "FaPhone","FaPhoneSlash","FaPhoneVolume","FaVideo","FaVideoSlash",
  "FaPaperPlane","FaPaperclip","FaReply","FaReplyAll","FaAt","FaHashtag",
  "FaShare",
  // Navigation & Arrows
  "FaChevronLeft","FaChevronRight","FaChevronUp","FaChevronDown",
  "FaArrowLeft","FaArrowRight","FaArrowUp","FaArrowDown",  
  "FaCaretLeft","FaCaretRight","FaCaretUp","FaCaretDown",
  // Media
  "FaPlay","FaPause","FaStop","FaForward","FaBackward","FaStepForward","FaStepBackward",
  "FaVolumeOff","FaMicrophone","FaMicrophoneSlash",
  "FaCamera","FaCameraRetro","FaImage","FaImages","FaFilm","FaMusic",
  "FaHeadphones","FaTv","FaDesktop",
  // Files & Documents
  "FaFile","FaFilePdf","FaFileImage","FaFileVideo","FaFileAudio","FaFileCode",
  "FaFileArchive","FaFileExcel","FaFileWord","FaFilePowerpoint","FaFileCsv",
  "FaFolder","FaFolderOpen","FaFolderPlus","FaFolderMinus",
  "FaDownload","FaUpload","FaCloud","FaCopy","FaPaste",
  // Actions
  "FaPlus","FaMinus","FaCheck","FaCheckDouble","FaPen",
  "FaTrash","FaUndo","FaFilter","FaSort",
  "FaSortUp","FaSortDown","FaPrint",
  "FaCrop","FaExpand","FaCompress",
  // Status & Alerts
  "FaCircle","FaBan","FaInfo",
  "FaExclamation","FaQuestion","FaBell","FaBellSlash",
  // Security & Auth
  "FaLock","FaLockOpen","FaKey","FaFingerprint",
  "FaEye","FaEyeSlash","FaUserShield","FaLockOpen",
  // Business & Finance
  "FaBriefcase","FaBuilding","FaStore","FaCartPlus",
  "FaTag","FaTags","FaReceipt","FaCreditCard","FaMoneyBill","FaMoneyBillWave","FaCoins",
  "FaDollarSign","FaPercent","FaChartBar","FaChartLine","FaChartPie","FaTable",
  // Calendar & Time
  "FaCalendar","FaCalendarCheck","FaCalendarPlus","FaCalendarMinus",
  "FaCalendarWeek","FaCalendarDay","FaClock","FaHourglassStart",
  "FaHourglassHalf","FaHourglassEnd","FaHourglass","FaStopwatch","FaStopwatch20",
  // Location
  "FaLocationArrow","FaMap",
  "FaMapPin","FaCompass","FaRoute","FaGlobe","FaSatellite",
  // Social / Brands
  "FaGithub","FaGitlab","FaGit","FaGoogle","FaFacebook","FaTwitter","FaLinkedin","FaInstagram",
  "FaYoutube","FaTwitch","FaDiscord","FaSlack","FaDropbox","FaFigma","FaApple","FaWindows",
  "FaAndroid","FaLinux","FaDocker","FaNpm","FaNodeJs","FaReact","FaVuejs","FaAngular",
  "FaPython","FaJava","FaPhp","FaRust","FaAws","FaStripe","FaPaypal","FaBitcoin",
  "FaWordpress","FaReddit","FaWhatsapp","FaTelegram","FaSpotify","FaStackOverflow",
  // Settings & System
  "FaWrench","FaToolbox","FaDatabase","FaServer",
  "FaNetworkWired","FaTerminal","FaCode","FaCodeBranch","FaCog","FaCogs","FaLayerGroup","FaCube","FaCubes",
  // Misc
  "FaStar","FaStarHalf","FaHeart",
  "FaBookmark","FaBook","FaBookOpen","FaGraduationCap","FaAward","FaMedal","FaTrophy",
  "FaRocket","FaHome","FaBolt","FaFire","FaLeaf","FaTree","FaSun",
  "FaMoon","FaSnowflake","FaCloud","FaWifi","FaBluetooth","FaBatteryFull","FaBatteryHalf",
  "FaBatteryQuarter","FaBatteryEmpty","FaMobile","FaTablet","FaLaptop",
  "FaKeyboard","FaMouse","FaHeadset","FaPowerOff","FaToggleOn","FaToggleOff",
  "FaListUl","FaListOl","FaGripLines","FaGripVertical",
  "FaBars","FaBox","FaBoxOpen",
  "FaWarehouse","FaClipboard","FaClipboardCheck","FaClipboardList",
  "FaNewspaper", "FaInbox", "FaAddressBook","FaAddressCard",
  "FaBicycle","FaCar","FaTruck","FaPlane","FaTrain",
  "FaBus","FaShip","FaHelicopter","FaMotorcycle","FaAmbulance",
];

// ---------------------------------------------------------------------------
// Ionicons 5  (react-icons/io5)
// ---------------------------------------------------------------------------
export const IO_ICONS = [
  // Outline variants
  "IoAccessibilityOutline","IoAddCircleOutline","IoAddOutline","IoAlarmOutline","IoAlbumsOutline",
  "IoAlertCircleOutline","IoAlertOutline","IoAnalyticsOutline","IoApertureOutline","IoAppsOutline",
  "IoArchiveOutline","IoArrowBackCircleOutline","IoArrowBackOutline","IoArrowDownCircleOutline",
  "IoArrowDownOutline","IoArrowForwardCircleOutline","IoArrowForwardOutline",
  "IoArrowRedoCircleOutline","IoArrowRedoOutline","IoArrowUndoCircleOutline","IoArrowUndoOutline",
  "IoArrowUpCircleOutline","IoArrowUpOutline","IoAtCircleOutline","IoAtOutline","IoAttachOutline",
  "IoBagAddOutline","IoBagCheckOutline","IoBagHandleOutline","IoBagOutline","IoBagRemoveOutline",
  "IoBanOutline","IoBandageOutline","IoBarChartOutline","IoBarbellOutline","IoBatteryChargingOutline",
  "IoBatteryDeadOutline","IoBatteryFullOutline","IoBatteryHalfOutline","IoBeakerOutline",
  "IoBedOutline","IoBeerOutline","IoBicycleOutline","IoBodyOutline","IoBonfireOutline",
  "IoBookOutline","IoBookmarkOutline","IoBookmarksOutline","IoBriefcaseOutline","IoBrowsersOutline",
  "IoBrushOutline","IoBugOutline","IoBuildOutline","IoBulbOutline","IoBusOutline","IoBusinessOutline",
  "IoCafeOutline","IoCalculatorOutline","IoCalendarClearOutline","IoCalendarNumberOutline",
  "IoCalendarOutline","IoCameraOutline","IoCameraReverseOutline","IoCarOutline","IoCardOutline",
  "IoCaretBackCircleOutline","IoCaretBackOutline","IoCaretDownCircleOutline","IoCaretDownOutline",
  "IoCaretForwardCircleOutline","IoCaretForwardOutline","IoCaretUpCircleOutline","IoCaretUpOutline",
  "IoCashOutline","IoCellularOutline","IoChatboxEllipsesOutline","IoChatboxOutline",
  "IoChatbubbleEllipsesOutline","IoChatbubbleOutline","IoChatbubblesOutline","IoCheckboxOutline",
  "IoCheckmarkCircleOutline","IoCheckmarkDoneCircleOutline","IoCheckmarkDoneOutline",
  "IoCheckmarkOutline","IoChevronBackCircleOutline","IoChevronBackOutline",
  "IoChevronDownCircleOutline","IoChevronDownOutline","IoChevronForwardCircleOutline",
  "IoChevronForwardOutline","IoChevronUpCircleOutline","IoChevronUpOutline","IoClipboardOutline",
  "IoCloseCircleOutline","IoCloseOutline","IoCloudCircleOutline","IoCloudDoneOutline",
  "IoCloudDownloadOutline","IoCloudOfflineOutline","IoCloudOutline","IoCloudUploadOutline",
  "IoCodeDownloadOutline","IoCodeOutline","IoCodeSlashOutline","IoCodeWorkingOutline",
  "IoColorFillOutline","IoColorFilterOutline","IoColorPaletteOutline","IoColorWandOutline",
  "IoCompassOutline","IoConstructOutline","IoContractOutline","IoCopyOutline","IoCreateOutline",
  "IoCropOutline","IoCubeOutline","IoCutOutline","IoDesktopOutline","IoDiamondOutline",
  "IoDiceOutline","IoDiscOutline","IoDocumentAttachOutline","IoDocumentLockOutline",
  "IoDocumentOutline","IoDocumentTextOutline","IoDocumentsOutline","IoDownloadOutline",
  "IoEarOutline","IoEarthOutline","IoEaselOutline","IoEggOutline","IoEllipseOutline",
  "IoEllipsisHorizontalCircleOutline","IoEllipsisHorizontalOutline",
  "IoEllipsisVerticalCircleOutline","IoEllipsisVerticalOutline","IoEnterOutline","IoExitOutline",
  "IoExpandOutline","IoExtensionPuzzleOutline","IoEyeOffOutline","IoEyeOutline","IoFastFoodOutline",
  "IoFileTrayFullOutline","IoFileTrayOutline","IoFileTrayStackedOutline","IoFilmOutline",
  "IoFilterCircleOutline","IoFilterOutline","IoFitnessOutline",
  "IoFlagOutline","IoFlameOutline","IoFlashOffOutline","IoFlashOutline","IoFlashlightOutline",
  "IoFlowerOutline","IoFolderOpenOutline","IoFolderOutline","IoFootballOutline","IoFunnelOutline",
  "IoGameControllerOutline","IoGiftOutline","IoGitBranchOutline","IoGitCommitOutline",
  "IoGitCompareOutline","IoGitMergeOutline","IoGitNetworkOutline","IoGitPullRequestOutline",
  "IoGlassesOutline","IoGlobeOutline","IoGridOutline","IoHammerOutline","IoHandLeftOutline",
  "IoHandRightOutline","IoHardwareChipOutline","IoHeadsetOutline","IoHeartCircleOutline",
  "IoHeartDislikeCircleOutline","IoHeartDislikeOutline","IoHeartHalfOutline","IoHeartOutline",
  "IoHelpBuoyOutline","IoHelpCircleOutline","IoHelpOutline","IoHomeOutline","IoHourglassOutline",
  "IoIdCardOutline","IoImageOutline","IoImagesOutline","IoInformationCircleOutline",
  "IoInformationOutline","IoJournalOutline","IoKeyOutline","IoKeypadOutline","IoLanguageOutline",
  "IoLaptopOutline","IoLayersOutline","IoLeafOutline","IoLibraryOutline","IoLinkOutline",
  "IoListCircleOutline","IoListOutline","IoLocateOutline","IoLocationOutline",
  "IoLockClosedOutline","IoLockOpenOutline","IoLogInOutline","IoLogOutOutline",
  "IoMailOpenOutline","IoMailOutline","IoMailUnreadOutline","IoMapOutline","IoMedicalOutline",
  "IoMedkitOutline","IoMegaphoneOutline","IoMenuOutline","IoMicCircleOutline",
  "IoMicOffCircleOutline","IoMicOffOutline","IoMicOutline","IoMoonOutline","IoMoveOutline",
  "IoMusicalNoteOutline","IoMusicalNotesOutline","IoNavigateCircleOutline","IoNavigateOutline",
  "IoNewspaperOutline","IoNotificationsCircleOutline","IoNotificationsOffCircleOutline",
  "IoNotificationsOffOutline","IoNotificationsOutline","IoNuclearOutline","IoNutritionOutline",
  "IoOpenOutline","IoOptionsOutline","IoPaperPlaneOutline","IoPauseCircleOutline","IoPauseOutline",
  "IoPawOutline","IoPencilOutline","IoPeopleCircleOutline","IoPeopleOutline",
  "IoPersonAddOutline","IoPersonCircleOutline","IoPersonOutline","IoPersonRemoveOutline",
  "IoPhoneCallOutline","IoPhoneLandscapeOutline","IoPhoneOutline","IoPhonePortraitOutline",
  "IoPieChartOutline","IoPinOutline","IoPlanetOutline","IoPlayBackCircleOutline","IoPlayBackOutline",
  "IoPlayCircleOutline","IoPlayForwardCircleOutline","IoPlayForwardOutline","IoPlayOutline",
  "IoPlaySkipBackCircleOutline","IoPlaySkipBackOutline","IoPlaySkipForwardCircleOutline",
  "IoPlaySkipForwardOutline","IoPodiumOutline","IoPowerOutline","IoPricetagOutline",
  "IoPricetagsOutline","IoPrintOutline","IoPrismOutline","IoPulseOutline","IoQrCodeOutline",
  "IoRadioButtonOffOutline","IoRadioButtonOnOutline","IoRadioOutline","IoRainyOutline",
  "IoReaderOutline","IoReceiptOutline","IoRefreshCircleOutline","IoRefreshOutline",
  "IoReloadCircleOutline","IoRemoveCircleOutline","IoRemoveOutline","IoReorderFourOutline",
  "IoReorderThreeOutline","IoReorderTwoOutline","IoRepeatOutline","IoResizeOutline",
  "IoRestaurantOutline","IoRibbonOutline","IoRocketOutline","IoRoseOutline","IoSadOutline",
  "IoSaveOutline","IoScanCircleOutline","IoScanOutline","IoSchoolOutline","IoSearchCircleOutline",
  "IoSearchOutline","IoSendOutline","IoServerOutline","IoSettingsOutline","IoShareOutline",
  "IoShareSocialOutline","IoShieldCheckmarkOutline","IoShieldHalfOutline","IoShieldOutline",
  "IoShirtOutline","IoShuffleOutline","IoSkullOutline","IoSnowOutline","IoSpeedometerOutline",
  "IoSquareOutline","IoStarHalfOutline","IoStarOutline","IoStatsChartOutline",
  "IoStopCircleOutline","IoStopOutline","IoStopwatchOutline","IoSubwayOutline","IoSunnyOutline",
  "IoSwapHorizontalOutline","IoSwapVerticalOutline","IoSyncCircleOutline","IoSyncOutline",
  "IoTabletLandscapeOutline","IoTabletPortraitOutline","IoTelescopeOutline","IoTerminalOutline",
  "IoTextOutline","IoThumbsDownOutline","IoThumbsUpOutline","IoThunderstormOutline",
  "IoTicketOutline","IoTimeOutline","IoTimerOutline","IoTodayOutline","IoToggleOutline",
  "IoTrailSignOutline","IoTrainOutline","IoTrashBinOutline","IoTrashOutline",
  "IoTrendingDownOutline","IoTrendingUpOutline","IoTriangleOutline","IoTrophyOutline",
  "IoTvOutline","IoUmbrellaOutline","IoVideocamOffOutline","IoVideocamOutline",
  "IoVolumeHighOutline","IoVolumeLowOutline","IoVolumeMediumOutline","IoVolumeMuteOutline",
  "IoVolumeOffOutline","IoWalkOutline","IoWalletOutline","IoWarningOutline","IoWatchOutline",
  "IoWaterOutline","IoWifiOutline","IoWineOutline","IoWomanOutline",
  // Filled (no suffix)
  "IoAccessibility","IoAddCircle","IoAdd","IoAlarm","IoAlbums","IoAlertCircle","IoAlert",
  "IoAnalytics","IoAperture","IoApps","IoArchive","IoArrowBackCircle","IoArrowBack",
  "IoArrowDownCircle","IoArrowDown","IoArrowForwardCircle","IoArrowForward","IoArrowRedoCircle",
  "IoArrowRedo","IoArrowUndoCircle","IoArrowUndo","IoArrowUpCircle","IoArrowUp","IoAtCircle",
  "IoAt","IoAttach","IoBagAdd","IoBagCheck","IoBagHandle","IoBag","IoBagRemove",
  "IoBan","IoBandage","IoBarChart","IoBarbell","IoBatteryCharging","IoBatteryDead",
  "IoBatteryFull","IoBatteryHalf","IoBeaker","IoBed","IoBeer","IoBicycle","IoBody",
  "IoBonfire","IoBook","IoBookmark","IoBookmarks","IoBriefcase","IoBrowsers","IoBrush",
  "IoBug","IoBuild","IoBulb","IoBus","IoBusiness","IoCafe","IoCalculator","IoCalendarClear",
  "IoCalendarNumber","IoCalendar","IoCamera","IoCameraReverse","IoCar","IoCard",
  "IoCaretBackCircle","IoCaretBack","IoCaretDownCircle","IoCaretDown","IoCaretForwardCircle",
  "IoCaretForward","IoCaretUpCircle","IoCaretUp","IoCash","IoCellular",
  "IoChatboxEllipses","IoChatbox","IoChatbubbleEllipses","IoChatbubble","IoChatbubbles",
  "IoCheckbox","IoCheckmarkCircle","IoCheckmarkDoneCircle","IoCheckmarkDone","IoCheckmark",
  "IoChevronBackCircle","IoChevronBack","IoChevronDownCircle","IoChevronDown",
  "IoChevronForwardCircle","IoChevronForward","IoChevronUpCircle","IoChevronUp",
  "IoClipboard","IoCloseCircle","IoClose","IoCloudCircle","IoCloudDone","IoCloudDownload",
  "IoCloudOffline","IoCloud","IoCloudUpload","IoCodeDownload","IoCode","IoCodeSlash",
  "IoColorFill","IoColorFilter","IoColorPalette","IoColorWand","IoCompass","IoConstruct",
  "IoContract","IoCopy","IoCreate","IoCrop","IoCube","IoCut","IoDesktop","IoDiamond",
  "IoDice","IoDisc","IoDocumentAttach","IoDocumentLock","IoDocument","IoDocumentText",
  "IoDocuments","IoDownload","IoEar","IoEarth","IoEasel","IoEgg","IoEllipse",
  "IoEllipsisHorizontalCircle","IoEllipsisHorizontal","IoEllipsisVerticalCircle",
  "IoEllipsisVertical","IoEnter","IoExit","IoExpand","IoExtensionPuzzle","IoEyeOff","IoEye",
  "IoFastFood","IoFileTrayFull","IoFileTray","IoFileTrayStacked","IoFilm","IoFilterCircle",
  "IoFilter","IoFingerprint","IoFitness","IoFlag","IoFlame","IoFlashOff","IoFlash",
  "IoFlashlight","IoFlower","IoFolderOpen","IoFolder","IoFootball","IoFunnel",
  "IoGameController","IoGift","IoGitBranch","IoGitCommit","IoGitCompare","IoGitMerge",
  "IoGitNetwork","IoGitPullRequest","IoGlasses","IoGlobe","IoGrid","IoHammer",
  "IoHandLeft","IoHandRight","IoHardwareChip","IoHeadset","IoHeartCircle",
  "IoHeartDislikeCircle","IoHeartDislike","IoHeartHalf","IoHeart","IoHelpBuoy",
  "IoHelpCircle","IoHelp","IoHome","IoHourglass","IoIdCard","IoImage","IoImages",
  "IoInformationCircle","IoInformation","IoJournal","IoKey","IoKeypad","IoLanguage",
  "IoLaptop","IoLayers","IoLeaf","IoLibrary","IoLink","IoListCircle","IoList",
  "IoLocate","IoLocation","IoLockClosed","IoLockOpen","IoLogIn","IoLogOut",
  "IoMailOpen","IoMail","IoMailUnread","IoMap","IoMedical","IoMedkit","IoMegaphone",
  "IoMenu","IoMicCircle","IoMicOffCircle","IoMicOff","IoMic","IoMoon","IoMove",
  "IoMusicalNote","IoMusicalNotes","IoNavigateCircle","IoNavigate","IoNewspaper",
  "IoNotificationsCircle","IoNotificationsOffCircle","IoNotificationsOff","IoNotifications",
  "IoNuclear","IoNutrition","IoOpen","IoOptions","IoPaperPlane","IoPauseCircle","IoPause",
  "IoPaw","IoPencil","IoPeopleCircle","IoPeople","IoPersonAdd","IoPersonCircle","IoPerson",
  "IoPersonRemove","IoPhoneLandscape","IoPhonePortrait","IoPieChart",
  "IoPin","IoPlanet","IoPlayBackCircle","IoPlayBack","IoPlayCircle","IoPlayForwardCircle",
  "IoPlayForward","IoPlay","IoPlaySkipBackCircle","IoPlaySkipBack","IoPlaySkipForwardCircle",
  "IoPlaySkipForward","IoPodium","IoPower","IoPricetag","IoPricetags","IoPrint","IoPrism",
  "IoPulse","IoQrCode","IoRadioButtonOff","IoRadioButtonOn","IoRadio","IoRainy","IoReader",
  "IoReceipt","IoRefreshCircle","IoRefresh","IoReloadCircle","IoRemoveCircle","IoRemove",
  "IoReorderFour","IoReorderThree","IoReorderTwo","IoRepeat","IoResize","IoRestaurant",
  "IoRibbon","IoRocket","IoRose","IoSad","IoSave","IoScanCircle","IoScan","IoSchool",
  "IoSearchCircle","IoSearch","IoSend","IoServer","IoSettings","IoShare","IoShareSocial",
  "IoShieldCheckmark","IoShieldHalf","IoShield","IoShirt","IoShuffle","IoSkull","IoSnow",
  "IoSpeedometer","IoSquare","IoStarHalf","IoStar","IoStatsChart","IoStopCircle","IoStop",
  "IoStopwatch","IoSubway","IoSunny","IoSwapHorizontal","IoSwapVertical","IoSyncCircle",
  "IoSync","IoTabletLandscape","IoTabletPortrait","IoTelescope","IoTerminal","IoText",
  "IoThumbsDown","IoThumbsUp","IoThunderstorm","IoTicket","IoTime","IoTimer","IoToday",
  "IoToggle","IoTrailSign","IoTrain","IoTrashBin","IoTrash","IoTrendingDown","IoTrendingUp",
  "IoTriangle","IoTrophy","IoTv","IoUmbrella","IoVideocamOff","IoVideocam","IoVolumeHigh",
  "IoVolumeLow","IoVolumeMedium","IoVolumeMute","IoVolumeOff","IoWalk","IoWallet",
  "IoWarning","IoWatch","IoWater","IoWifi","IoWine","IoWoman",
  // Sharp
  "IoAddCircleSharp","IoAddSharp","IoAlarmSharp","IoAlertCircleSharp","IoAlertSharp",
  "IoAnalyticsSharp","IoArchiveSharp","IoArrowBackCircleSharp","IoArrowBackSharp",
  "IoArrowDownCircleSharp","IoArrowDownSharp","IoArrowForwardCircleSharp","IoArrowForwardSharp",
  "IoArrowUpCircleSharp","IoArrowUpSharp","IoBanSharp","IoBarChartSharp","IoBookmarkSharp",
  "IoBookSharp","IoBriefcaseSharp","IoBrushSharp","IoBugSharp","IoBuildSharp","IoBulbSharp",
  "IoBusinessSharp","IoCalendarSharp","IoCameraSharp","IoCardSharp","IoCaretDownSharp",
  "IoCaretUpSharp","IoCashSharp","IoChatboxSharp","IoChatbubbleSharp","IoCheckmarkCircleSharp",
  "IoCheckmarkSharp","IoChevronDownSharp","IoChevronUpSharp","IoClipboardSharp",
  "IoCloseCircleSharp","IoCloseSharp","IoCloudSharp","IoCodeSharp","IoColorPaletteSharp",
  "IoCompassSharp","IoCopySharp","IoCreateSharp","IoDesktopSharp","IoDocumentSharp",
  "IoDownloadSharp","IoEyeSharp","IoFilterSharp","IoFlagSharp","IoFolderSharp","IoGridSharp",
  "IoHeartSharp","IoHomeSharp","IoImageSharp","IoInformationCircleSharp","IoKeySharp",
  "IoLayersSharp","IoLinkSharp","IoListSharp","IoLocationSharp","IoLockClosedSharp",
  "IoMailSharp","IoMenuSharp","IoMicSharp","IoPencilSharp","IoPersonSharp",
  "IoPieChartSharp","IoPrintSharp","IoRefreshSharp","IoRemoveSharp","IoRocketSharp",
  "IoSaveSharp","IoSearchSharp","IoSendSharp","IoServerSharp","IoSettingsSharp","IoShareSharp",
  "IoShieldSharp","IoStarSharp","IoStopSharp","IoSunnySharp","IoSyncSharp","IoTimeSharp",
  "IoTimerSharp","IoTrashSharp","IoTrophySharp","IoTvSharp","IoWarningSharp","IoWifiSharp",
];

// ---------------------------------------------------------------------------
// Material Design  (react-icons/md)
// ---------------------------------------------------------------------------
export const MD_ICONS = [
  // Action
  "MdAccessibility","MdAccessibilityNew","MdAccessAlarm","MdAccountBalance","MdAccountBalanceWallet",
  "MdAccountBox","MdAccountCircle","MdAccountTree","MdAdd","MdAddAlert","MdAddBox","MdAddCircle",
  "MdAddCircleOutline","MdAddComment","MdAddLink","MdAddLocation","MdAddShoppingCart","MdAddTask",
  "MdAdminPanelSettings","MdAlarm","MdAlarmAdd","MdAlarmOff","MdAlarmOn","MdAllInbox","MdAllOut",
  "MdAnalytics","MdAndroid","MdAnnouncement","MdApi","MdApproval","MdApps","MdArchive",
  "MdArrowBack","MdArrowBackIos","MdArrowBackIosNew","MdArrowCircleDown","MdArrowCircleLeft",
  "MdArrowCircleRight","MdArrowCircleUp","MdArrowDownward","MdArrowDropDown","MdArrowDropDownCircle",
  "MdArrowDropUp","MdArrowForward","MdArrowForwardIos","MdArrowLeft","MdArrowOutward",
  "MdArrowRight","MdArrowRightAlt","MdArrowUpward","MdArticle","MdAspectRatio","MdAssessment",
  "MdAssignment","MdAssignmentInd","MdAssignmentLate","MdAssignmentReturn","MdAssignmentReturned",
  "MdAssignmentTurnedIn","MdAttachFile","MdAttachMoney","MdAttachment","MdAutorenew","MdBackup",
  "MdBackupTable","MdBadge","MdBalcony","MdBallot","MdBarChart","MdBlock","MdBookmark",
  "MdBookmarkAdd","MdBookmarkAdded","MdBookmarkBorder","MdBookmarkRemove","MdBookmarks",
  "MdBrightnessMedium","MdBrokenImage","MdBugReport","MdBuild","MdBuildCircle","MdBusiness",
  "MdBusinessCenter","MdCalculate","MdCalendarMonth","MdCalendarToday","MdCalendarViewDay",
  "MdCalendarViewMonth","MdCalendarViewWeek","MdCall","MdCallEnd","MdCallMade","MdCallMerge",
  "MdCallMissed","MdCallMissedOutgoing","MdCallReceived","MdCallSplit","MdCamera","MdCameraAlt",
  "MdCancel","MdCancelPresentation","MdCardGiftcard","MdCardMembership","MdCardTravel",
  "MdCast","MdCastConnected","MdCategory","MdChat","MdChatBubble","MdChatBubbleOutline",
  "MdCheck","MdCheckBox","MdCheckBoxOutlineBlank","MdCheckCircle","MdCheckCircleOutline",
  "MdChecklist","MdChevronLeft","MdChevronRight","MdClass","MdClose","MdClosedCaption",
  "MdCloud","MdCloudCircle","MdCloudDone","MdCloudDownload","MdCloudOff","MdCloudQueue",
  "MdCloudSync","MdCloudUpload","MdCode","MdCodeOff","MdComment","MdCommit",
  "MdCompare","MdCompareArrows","MdComputer","MdConfirmationNumber","MdConstruction",
  "MdContactMail","MdContactPage","MdContactPhone","MdContacts","MdContentCopy","MdContentCut",
  "MdContentPaste","MdCopyright","MdCreate","MdCreateNewFolder","MdCreditCard","MdCreditScore",
  "MdDangerous","MdDarkMode","MdDashboard","MdDashboardCustomize","MdDateRange",
  "MdDelete","MdDeleteForever","MdDeleteOutline","MdDeleteSweep","MdDesignServices",
  "MdDesktopMac","MdDesktopWindows","MdDeveloperMode","MdDiamond","MdDialpad","MdDifference",
  "MdDns","MdDoNotDisturb","MdDoNotDisturbAlt","MdDoNotDisturbOff","MdDoNotDisturbOn",
  "MdDone","MdDoneAll","MdDoneOutline","MdDownload","MdDownloadDone","MdDownloadForOffline",
  "MdDrafts","MdDragHandle","MdDragIndicator","MdEdit","MdEditCalendar","MdEditLocation",
  "MdEditNote","MdEditNotifications","MdEditOff","MdEditRoad","MdEmail","MdEmergency",
  "MdEmojiEmotions","MdEmojiEvents","MdEmojiFlags","MdEmojiNature","MdEmojiObjects",
  "MdEmojiPeople","MdEmojiSymbols","MdEmojiTransportation","MdEngineering","MdError",
  "MdErrorOutline","MdEuroSymbol","MdEvent","MdEventAvailable","MdEventBusy","MdEventNote",
  "MdEventRepeat","MdEventSeat","MdExitToApp","MdExpand","MdExpandLess","MdExpandMore",
  "MdExplicit","MdExplore","MdExploreOff","MdExtension","MdFace","MdFavorite","MdFavoriteBorder",
  "MdFeedback","MdFiberNew","MdFileCopy","MdFileDownload","MdFileDownloadDone","MdFileOpen",
  "MdFilePresent","MdFileUpload","MdFilter","MdFilterAlt","MdFilterAltOff","MdFilterList",
  "MdFilterListOff","MdFindInPage","MdFindReplace","MdFingerprint","MdFlag","MdFlagCircle",
  "MdFolder","MdFolderCopy","MdFolderDelete","MdFolderOff","MdFolderOpen","MdFolderShared",
  "MdFolderSpecial","MdFolderZip","MdFormatAlignCenter","MdFormatAlignJustify",
  "MdFormatAlignLeft","MdFormatAlignRight","MdFormatBold","MdFormatClear","MdFormatColorFill",
  "MdFormatColorText","MdFormatIndentDecrease","MdFormatIndentIncrease","MdFormatItalic",
  "MdFormatListBulleted","MdFormatListNumbered","MdFormatQuote","MdFormatSize","MdFormatUnderlined",
  "MdForum","MdForward","MdFullscreen","MdFullscreenExit","MdFunctions","MdGlobe","MdGrade",
  "MdGroup","MdGroupAdd","MdGroupOff","MdGroupRemove","MdGroupWork","MdGroups","MdHandshake",
  "MdHeadphones","MdHeadset","MdHeadsetMic","MdHeadsetOff","MdHelp","MdHelpCenter",
  "MdHelpOutline","MdHighlight","MdHighlightAlt","MdHighlightOff","MdHistory","MdHistoryEdu",
  "MdHome","MdHomeRepairService","MdHomeWork","MdHorizontalRule","MdHotel", 
  "MdHourglassBottom","MdHourglassDisabled","MdHourglassEmpty","MdHourglassFull","MdHourglassTop",
  "MdHttp","MdHttps","MdHub","MdImage","MdImageSearch","MdImportContacts","MdImportExport",
  "MdInbox","MdInfo","MdInput","MdInsertChart","MdInsertComment","MdInsertDriveFile",
  "MdInsertEmoticon","MdInsertLink","MdInsertPhoto","MdInventory","MdInvertColors",
  "MdIosShare","MdLabel","MdLabelImportant","MdLabelOff","MdLanguage","MdLaptop",
  "MdLaptopMac","MdLaptopWindows","MdLeaderboard","MdLibraryAdd","MdLibraryAddCheck",
  "MdLibraryBooks","MdLibraryMusic","MdLightMode","MdLightbulb","MdLightbulbCircle",
  "MdLink","MdLinkOff","MdList","MdListAlt","MdLiveTv","MdLocalActivity","MdLocalAirport",
  "MdLocalAtm","MdLocalBar","MdLocalCafe","MdLocalGasStation","MdLocalGroceryStore",
  "MdLocalHospital","MdLocalHotel","MdLocalLibrary","MdLocalMall","MdLocalMovies","MdLocalOffer",
  "MdLocalPhone","MdLocalPizza","MdLocalPlay","MdLocalPolice","MdLocalPostOffice","MdLocalSee",
  "MdLocalShipping","MdLocalTaxi","MdLocationCity","MdLocationDisabled","MdLocationOff",
  "MdLocationOn","MdLocationPin","MdLocationSearching","MdLock","MdLockClock","MdLockOpen",
  "MdLockOutline","MdLockPerson","MdLogin","MdLogout","MdLoop","MdMail","MdMailLock",
  "MdMailOutline","MdManageAccounts","MdManageSearch","MdMap","MdMapsHomeWork",
  "MdMarkAsUnread","MdMarkChatRead","MdMarkChatUnread","MdMarkEmailRead","MdMarkEmailUnread",
  "MdMenu","MdMenuBook","MdMenuOpen","MdMessage","MdMic","MdMicExternalOff","MdMicExternalOn",
  "MdMicNone","MdMicOff","MdMobileOff","MdModeComment","MdModeEdit","MdModeEditOutline",
  "MdModeNight","MdMonetizationOn","MdMoneyOff","MdMonitor","MdMoreHoriz","MdMoreVert",
  "MdMouse","MdMovie","MdMusicNote","MdMusicOff","MdMusicVideo","MdMyLocation","MdNearMe",
  "MdNetworkCell","MdNetworkCheck","MdNetworkWifi","MdNewReleases","MdNewspaper","MdNextPlan",
  "MdNightlight","MdNoAccounts","MdNoCell","MdNoEncryption","MdNoFlash","MdNoPhotography",
  "MdNotStarted","MdNoteAdd","MdNoteAlt","MdNotes","MdNotificationAdd","MdNotificationImportant",
  "MdNotifications","MdNotificationsActive","MdNotificationsNone","MdNotificationsOff",
  "MdNotificationsPaused","MdOpenInBrowser","MdOpenInFull","MdOpenInNew","MdOpenInNewOff",
  "MdOpenWith","MdOutbox","MdPaid","MdPalette","MdPanTool","MdPassword","MdPause",
  "MdPauseCircle","MdPauseCircleFilled","MdPauseCircleOutline","MdPayment","MdPayments",
  "MdPending","MdPendingActions","MdPercent","MdPerson","MdPersonAdd","MdPersonAddAlt",
  "MdPersonOff","MdPersonOutline","MdPersonPin","MdPersonPinCircle","MdPersonRemove",
  "MdPersonSearch","MdPhone","MdPhoneAndroid","MdPhoneCallback","MdPhoneDisabled",
  "MdPhoneEnabled","MdPhoneForwarded","MdPhoneInTalk","MdPhoneIphone","MdPhoneLocked",
  "MdPhoneMissed","MdPhonePaused","MdPhotoAlbum","MdPhotoCamera","MdPhotoLibrary","MdPhoto",
  "MdPictureAsPdf","MdPieChart","MdPieChartOutline","MdPin","MdPinDrop","MdPlace",
  "MdPlayArrow","MdPlayCircle","MdPlayCircleFilled","MdPlayCircleOutline","MdPlaylistAdd",
  "MdPlaylistAddCheck","MdPlaylistPlay","MdPlaylistRemove","MdPolicy","MdPower","MdPowerOff",
  "MdPowerSettingsNew","MdPreview","MdPrint","MdPrintDisabled","MdPriorityHigh","MdPrivacyTip",
  "MdPublic","MdPublicOff","MdPublish","MdPushPin","MdQrCode","MdQrCode2","MdQrCodeScanner",
  "MdQueryBuilder","MdQuestionMark","MdQueue","MdQueueMusic","MdQueuePlayNext","MdQuickreply",
  "MdRadio","MdRadioButtonChecked","MdRadioButtonUnchecked","MdRateReview","MdReadMore",
  "MdReceipt","MdReceiptLong","MdRecentActors","MdRecommend","MdRecordVoiceOver","MdRedeem",
  "MdRedo","MdRefresh","MdRemoveCircle","MdRemoveCircleOutline","MdRemoveDone",
  "MdRemoveRedEye","MdRemoveShoppingCart","MdReorder","MdRepeat","MdRepeatOn","MdRepeatOne",
  "MdReplay","MdReply","MdReplyAll","MdReport","MdReportOff","MdReportProblem",
  "MdRestaurant","MdRestore","MdRestoreFromTrash","MdRestorePage","MdReviews","MdRingVolume",
  "MdRoom","MdRoomService","MdRoute","MdRssFeed","MdRule","MdRuleFolder","MdSave","MdSaveAlt",
  "MdSaveAs","MdSavings","MdScanner","MdSchedule","MdScheduleSend","MdSchool","MdSearch",
  "MdSearchOff","MdSecurity","MdSelectAll","MdSell","MdSend","MdSendAndArchive",
  "MdSettings","MdSettingsAccessibility","MdSettingsApplications","MdSettingsBackupRestore",
  "MdSettingsBluetooth","MdSettingsBrightness","MdSettingsCell","MdSettingsEthernet",
  "MdSettingsPhone","MdSettingsPower","MdSettingsRemote","MdSettingsSuggest","MdSettingsVoice",
  "MdShare","MdShareLocation","MdShield","MdShop","MdShoppingBag","MdShoppingBasket",
  "MdShoppingCart","MdShoppingCartCheckout","MdSort","MdSortByAlpha","MdSos","MdSpa",
  "MdSpaceBar","MdSpaceDashboard","MdSpeaker","MdSpeakerGroup","MdSpeakerNotes",
  "MdSpeakerNotesOff","MdSpeed","MdSpellcheck","MdStar","MdStarBorder","MdStarHalf",
  "MdStarRate","MdStars","MdStop","MdStopCircle","MdStorage","MdStore","MdStorefront",
  "MdStyle","MdSubject","MdSubscriptions","MdSubtitles","MdSubtitlesOff","MdSupportAgent",
  "MdSwapCalls","MdSwapHoriz","MdSwapVert","MdSync","MdSyncAlt","MdSyncDisabled",
  "MdSyncLock","MdSyncProblem","MdSystemUpdate","MdTab","MdTableChart","MdTableRows",
  "MdTableView","MdTablet","MdTabletAndroid","MdTabletMac","MdTag","MdTask","MdTaskAlt",
  "MdTextFields","MdTextFormat","MdThumbDown","MdThumbDownAlt","MdThumbUp","MdThumbUpAlt",
  "MdThumbsUpDown","MdTimelapse","MdTimeline","MdTimer","MdTimerOff","MdTipsAndUpdates",
  "MdTitle","MdToggleOff","MdToggleOn","MdTopic","MdTour","MdToys","MdTrackChanges",
  "MdTrain","MdTranslate","MdTrendingDown","MdTrendingFlat","MdTrendingUp","MdTroubleshoot",
  "MdTune","MdTv","MdTvOff","MdUnarchive","MdUndo","MdUnfoldLess","MdUnfoldMore",
  "MdUnpublished","MdUnsubscribe","MdUpdate","MdUpdateDisabled","MdUpgrade","MdUpload",
  "MdUploadFile","MdUsb","MdVerified","MdVerifiedUser","MdVerticalAlignBottom",
  "MdVerticalAlignCenter","MdVerticalAlignTop","MdVerticalSplit","MdVibration","MdVideoCall",
  "MdVideoFile","MdVideoLabel","MdVideoLibrary","MdVideoSettings","MdVideocam","MdVideocamOff",
  "MdVideogameAsset","MdViewAgenda","MdViewArray","MdViewCarousel","MdViewColumn","MdViewComfy",
  "MdViewDay","MdViewHeadline","MdViewInAr","MdViewKanban","MdViewList","MdViewModule",
  "MdViewQuilt","MdViewSidebar","MdViewStream","MdViewTimeline","MdViewWeek","MdVisibility",
  "MdVisibilityOff","MdVoiceChat","MdVoiceOverOff","MdVoicemail","MdVolumeDown","MdVolumeMute",
  "MdVolumeOff","MdVolumeUp","MdVpnKey","MdVpnKeyOff","MdVpnLock","MdWallet","MdWarning",
  "MdWarningAmber","MdWatch","MdWatchLater","MdWatchOff","MdWater","MdWaterDrop","MdWaves",
  "MdWavingHand","MdWbSunny","MdWebAsset","MdWebAssetOff","MdWebStories","MdWeekend",
  "MdWidgets","MdWifi","MdWifiCalling","MdWifiCalling3","MdWifiFind","MdWifiLock","MdWifiOff",
  "MdWifiTethering","MdWifiTetheringError","MdWifiTetheringOff","MdWindow","MdWork",
  "MdWorkHistory","MdWorkOff","MdWorkOutline","MdWrapText","MdWrongLocation","MdWysiwyg",
  "MdYard","MdZoomIn","MdZoomInMap","MdZoomOut","MdZoomOutMap",
];

export const ICON_LIST = [...new Set([...FA_ICONS, ...MD_ICONS, ...IO_ICONS])];

export const CATEGORIES = {
  All:    null,
  Io:     "Io",
  Fa:     "Fa",
  Md:     "Md",
};

export function getIconsByCategory(prefix) {
  if (!prefix) return ICON_LIST;
  return ICON_LIST.filter((name) => name.startsWith(prefix));
}

export function searchIcons(query, prefix) {
  const base = getIconsByCategory(prefix);
  if (!query.trim()) return base;
  return base.filter((name) => name.toLowerCase().includes(query.toLowerCase()));
}
